/* eslint-disable no-param-reassign */
import PropTypes from 'prop-types';
import { Dialog, DialogTitle } from '@material-ui/core';
import CollectionItemsListContainer from '../collection-items-list';

const PropertyItemsModal = (props) => {
  const { onClose, property, ...modalProps } = props;

  return (
    <Dialog onClose={onClose} {...modalProps}>
      <DialogTitle>Items of {property.name}</DialogTitle>
      <CollectionItemsListContainer property={property} />
    </Dialog>
  );
};

PropertyItemsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  property: PropTypes.any,
};

PropertyItemsModal.defaultProps = {
  property: null,
};

export default PropertyItemsModal;
